// extracted by mini-css-extract-plugin
export default {"graph":"LineGraph_graph__0Pwr9"};